import noop from '@anm/helpers/noop';
import { Config as FinalFormConfig } from 'final-form';
import { useCallback, FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';

import { InputVariants } from '../Input';
import { LabelVariant } from '../InputLabel';
import { TextField } from '../fields';

import { Row, Wrapper } from './Wrapper';

type HOCs = FinalFormConfig;

export type FieldProps = {
  name: string;
  label: string;
  placeholder: string;
  inputVariant: InputVariants;
  labelVariant: LabelVariant;
};

type ParamsFieldsProps = {
  fields: FieldProps[][];
};

type TabParamsFormProps = ParamsFieldsProps & {
  onBlur?: (values: any) => void;
};

export const ParamsFields: FC<ParamsFieldsProps> = ({ fields }) => (
  <>
    {fields.map(row => (
      <Row key={row[0].name}>
        {row.map(field => (
          <TextField key={field.name} {...field} />
        ))}
      </Row>
    ))}
  </>
);

const renderForm = ({ fields, onBlur = noop }: TabParamsFormProps) => ({
  values
}: FormRenderProps) => {
  const handleBlur = useCallback(() => onBlur(values), [onBlur, values]);

  return (
    <Wrapper onBlur={handleBlur}>
      <ParamsFields {...{ fields }} />
    </Wrapper>
  );
};

const TabParamsForm: FC<HOCs & TabParamsFormProps> = props => (
  <Form render={renderForm(props)} {...props} />
);

export default TabParamsForm;
